import React, { ReactElement } from "react";
import { TailSpin } from "react-loader-spinner";
import { Centered } from "./StyledComponents";

interface IWrapperProps {
  height?: number;
  width?: number;
}

const SpinnerWrapper = (props: IWrapperProps): ReactElement => (
  <Centered>
    <TailSpin height={props.height || 80} width={props.width || 80} color="black" />
  </Centered>
);

export default SpinnerWrapper;
